module.exports = "<div class=\"<%= location %>\">\r\n    <div class=\"<%= location__icon %>\">\r\n        <i class=\"fa fa-map-marker\"></i>\r\n    </div>\r\n    <div class=\"<%= location__address %>\">\r\n        <gw-pl-address-summary ng-if=\"location()\" address=\"location().address\"></gw-pl-address-summary>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/LocationReadonlyView/Location.html
// module id = 430
// module chunks = 0